<template>
  <section 
    ref="sectionRef"
    :id="id"
    :class="computedClasses"
  >
    <div :class="innerComputedClasses">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { cn } from '@/lib/utils'

interface Props {
  className?: string
  innerClassName?: string
  maxWidth?: string
  id?: string
}

const props = withDefaults(defineProps<Props>(), {
  className: '',
  innerClassName: '',
  maxWidth: 'max-w-[1440px]',
  id: undefined
})

const sectionRef = ref<HTMLElement | null>(null)

defineExpose({
  sectionRef
})

const computedClasses = computed(() => 
  cn('h-auto w-full flex items-center justify-center relative overflow-x-hidden', props.className)
)

const innerComputedClasses = computed(() => 
  cn('h-full w-full', props.maxWidth, 'flex items-center justify-center', props.innerClassName)
)
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>
